/*** IMPORTS FROM imports-loader ***/
var define = false;

import $ from 'jquery';

function mb_strlen(s) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(s.replace(/\r\n/g, '\n')).split(/%..|./).length;
}

function setupCharCounters(container) {
  $(container).find('.form-char-counter').each((idx, el) => {
    const $el = $(el);

    const $input = $el.closest('.form-group').find('input, textarea');
    if (!$input.length) {
      return;
    }

    const $max = $el.find('.max');
    const $remaining = $el.find('.remaining');

    const max = parseInt($el.data('max'), 10);

    const updateCharCountValues = () => {
      $max.text(max);
      $remaining.text(max - mb_strlen($input.val()));
    };

    updateCharCountValues();
    $input.on('keyup', updateCharCountValues);
  });
}

setupCharCounters(document.body);

export default setupCharCounters;

